var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"central-insert",staticStyle:{"background-color":"white","width":"500px"}},[_vm._v("\n    "+_vm._s(_vm._f("trans")('ownerReportDisabled'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }